import { Breadcrumb ,message } from 'antd';
import './IntellectualPropertyRights.less'
import copy from "copy-to-clipboard";

const handleCopy = (value:any) => {
	copy(value);
	message.success('Copy successful!');
}



export default () => (
	<div className="IntellectualPropertyRights">
		<div className="page-routers-header">
			<Breadcrumb className="page-header-content">
				<Breadcrumb.Item>
				  <a href="/">Home</a>
				</Breadcrumb.Item>
				<Breadcrumb.Item>Intellectual Property Rights</Breadcrumb.Item>
			</Breadcrumb>
		</div>
		<div className="page-footer-container">
			<div className="page-footer-content">
				<div className="page-title">Intellectual Property Rights</div>
				<div>
					<p>SNAILCLE does fully respect intellectual property rights of third parties and has a strict zero-tolerance policy against any counterfeit and/or infringement of intellectual property.We do regularly review the listings in our website in order to avoid any possible intellectual property infringement. If any listing is found to violate SNAILCLE’s policy, it will be removed.</p>
					<p>Despite our efforts to avoid any sale of infringing products on our website, due to the complexity of the products, providers and sellers, there are times in which we cannot detect or identify intellectual property infringements. That is why we strongly encourage our customers or intellectual property right holders to cooperate with us. In this sense, if you believe your intellectual property right has been infringed, we urge you to let us know about itby sending emails to <span onClick={() => {handleCopy('support@snailcle.com')}} className="email_text">support@snailcle.com</span>. Eligiblecomplaints include but not limited to below:</p>
					<ul className="content">
						<li>Trademark Infringement: Unauthorized use of an identical or similar trademark on goods which are identical with, or similar to, the goods for which the trademark is registered.</li>
						<li>Patent Infringement: Unauthorized use of others’ granted Design Patent or Utility Patent.</li>
						<li>Copyright Infringement: Unauthorized use of the content or photos created by others or sell others’ copyright works, including books, CDs, software, etc.</li>
						<li>Other activities that violate local Intellectual Property Law.</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
)